import http from "../http-common";

class UserService {
  
  // Retrieve all users
  get() {
    return http.get(`/user/`);
  }

  // Retrieve a user corresponding to a username
  getOne(id) {
    return http.get(`/user/${id}`);
  }

  getProfile(id) {
    return http.get(`/user/${id}/profile`);
  }

  // Retrieve infractions of a user on an optional period
  getInfractions(id, params = {}) {
    return http.get(`/user/${id}/infractions`, { params });
  }

  // Retrieve all users of a company
  getCompany(id) {
    console.log("get company" , id)
    return http.get(`/user/company/${id}`);
  }

  // Retrieve all users of one or more agencies
  getAgency(id) {
    return http.get(`/user/agency/${id}`);
  }

  // Update a user corresponding to a username
  update(id, data) {
    return http.put(`/user/${id}`, data);
  }

  // Create a user
  create(data) {
    return http.post(`/user/`,  data);
  }

  // Delete a user corresponding to a username
  delete(id) {
    return http.delete(`/user/${id}`);
  }
}

export default new UserService();

